module.exports = __webpack_public_path__ + "static/media/sysp.d35d360a.mp4";